module.exports = __webpack_public_path__ + "img/4.41ff829.webp";